<template>
  <v-select
    :disabled="disabled"
    :items="rasters"
    v-model="raster"
    item-text="displayName"
    prepend-inner-icon="nature"
    append-icon="keyboard_arrow_down"
    return-object
    persistent-hint
    :hint="`${$t('selecciona.raster')} ${indicador ? $t(`indicadores.${indicador}`) : ''}`"
  ></v-select>
</template>

<script>
import moment from 'moment'

import config from '@/config'
import getSortFunction from '../sort'

const months = moment.localeData('es').months().map(m => m.toLowerCase())
const trims = ['primavera', 'verano', 'otoño', 'invierno']

const geoserverURL = `${config.geoserver.geoserverURL}/wms`

/**
 * Componente para seleccionar un ráster de la lista y actualizar la store
 * con el ráster seleccionado
 */
export default {

  props: ['disabled', 'value'],

  computed: {

    raster: {
      get() { return this.$store.getters.raster },
      set(value) { this.$store.dispatch('setRaster', value) }
    },

    rasters() {
      const indicadores = this.$store.getters.indicadores
      const period = this.period
      const periodLower = this.period.toLowerCase()

      if(!indicadores[this.indicador] || !period) {
        return []
      }

      const layerNames = indicadores[this.indicador]

      return layerNames
        .filter(({name}) => name.indexOf(periodLower) > -1)
        .map(layerInfo => Object.assign({}, layerInfo, {
          name: `${config.geoserver.geoserverWorkspace}:${layerInfo.name}`,
          url: geoserverURL,
          displayName: this.getDisplayName(layerInfo.name)
        }))
        .sort(getSortFunction(period))
    },

    indicador() {
      return this.$store.getters.indicador
    },

    period() {
      return this.$store.getters.period
    }
  },

  methods: {
    getDisplayName(name) {
      const monthsLocale = moment.localeData(this.$store.getters.locale.key).months().map(m => m.toLowerCase())
      const period = this.period.toLowerCase()

      const displayArray = name
        .replace(this.indicador + '_', '')
        .replace(period + '_', '')
        .replace(/_/g, ' ')
        .split(' ')

      switch(period) {
        case 'anual': break;
        case 'mensual':
          var [m, y] = displayArray
          const monthIndex = months.findIndex(month => month == m)
          displayArray[0] = monthsLocale[monthIndex]
          break;
        case 'trimestral':
          var [t, y] = displayArray
          // Cambiamos la ñ por ny por otoño (Si no no lo reconoce)
          displayArray[0] = this.$t(`trimestres.${t.replace('ñ', 'ny')}`)
          break;        
      }

      return displayArray
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')

    },

    setDefaultRaster() {
      if(!this.value) {
        return
      }

      if(this.rasters.length) {
        this.raster = this.rasters[0]
      }
    },
  },

  watch: {
    value() {
      this.setDefaultRaster()
    },
    rasters() {
      this.setDefaultRaster()
    },
    indicador() {
      this.setDefaultRaster()
    },
    period() {
      this.setDefaultRaster()
    }
  }
}
</script>



// WEBPACK FOOTER //
// select-raster.vue?10936196